var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel-black",
    clipPath: "url(#clip0_92_4764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99992 1.33325C4.31325 1.33325 1.33325 4.31325 1.33325 7.99992C1.33325 11.6866 4.31325 14.6666 7.99992 14.6666C11.6866 14.6666 14.6666 11.6866 14.6666 7.99992C14.6666 4.31325 11.6866 1.33325 7.99992 1.33325ZM10.8666 10.8666C10.6066 11.1266 10.1866 11.1266 9.92659 10.8666L7.99992 8.93992L6.07325 10.8666C5.81325 11.1266 5.39325 11.1266 5.13325 10.8666C4.87325 10.6066 4.87325 10.1866 5.13325 9.92659L7.05992 7.99992L5.13325 6.07325C4.87325 5.81325 4.87325 5.39325 5.13325 5.13325C5.39325 4.87325 5.81325 4.87325 6.07325 5.13325L7.99992 7.05992L9.92659 5.13325C10.1866 4.87325 10.6066 4.87325 10.8666 5.13325C11.1266 5.39325 11.1266 5.81325 10.8666 6.07325L8.93992 7.99992L10.8666 9.92659C11.1199 10.1799 11.1199 10.6066 10.8666 10.8666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_4764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.91e1c2e89931a9c773b257674753bd48.svg";
export { ForwardRef as ReactComponent };